import { render, staticRenderFns } from "./CaptainComplaintsNoBooking.vue?vue&type=template&id=2cb87302"
import script from "./CaptainComplaintsNoBooking.vue?vue&type=script&lang=js"
export * from "./CaptainComplaintsNoBooking.vue?vue&type=script&lang=js"
import style0 from "./CaptainComplaintsNoBooking.vue?vue&type=style&index=0&id=2cb87302&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports